import {Typography, TypographyProps} from '@mui/material'
import React from 'react'

export const CardSectionTitle: React.FC<TypographyProps> = (props) => (
  <Typography variant="body1" {...props} />
)
